import throttle from 'lodash/throttle';

/**
 * Sticky Header functionnality
 */
export function stickyHeader() {
	const triggerHeight = 1;
	const $window = $( window );
	const $header = $( '.o__header' );

	window.addEventListener( 'scroll', throttle( () => {
		if ( $window.scrollTop() > triggerHeight ) {
			$header.addClass( 'o__header--active' );
		} else {
			$header.removeClass( 'o__header--active' );
		}
	}), 2000 );
}